import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAssets = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	viewBox: "-1.5 -1.5 23 23",
	fill: "none",
	preserveAspectRatio: "xMidYMid meet",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		stroke: "#748094",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.2,
		clipPath: "url(#a)",
		children: /* @__PURE__ */ _jsx("path", { d: "M9.556 2.319 7.313 4.562a.625.625 0 0 0 0 .883l2.241 2.242c.244.244.64.244.884 0l2.243-2.243a.625.625 0 0 0 0-.884L10.44 2.319a.625.625 0 0 0-.884 0M14.556 7.319l-2.243 2.243a.625.625 0 0 0 0 .883l2.241 2.242c.244.244.64.244.884 0l2.243-2.243a.625.625 0 0 0 0-.884L15.44 7.319a.625.625 0 0 0-.884 0M4.556 7.312 2.313 9.555a.625.625 0 0 0 0 .883l2.241 2.242c.244.244.64.244.884 0l2.243-2.243a.625.625 0 0 0 0-.884L5.44 7.312a.625.625 0 0 0-.884 0M9.556 12.312l-2.243 2.243a.625.625 0 0 0 0 .883l2.241 2.242c.244.244.64.244.884 0l2.243-2.243a.625.625 0 0 0 0-.884l-2.241-2.241a.625.625 0 0 0-.884 0" })
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "a",
		children: /* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "M-1.5-1.5H21.5V21.5H-1.5z"
		})
	}) })]
});
export default SvgAssets;
